import React, { useState, useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import MapComponents from "./map/MapComponents";
import ResetAllDisruption from "./map/ResetAllDisruption";
import { useDispatch, useSelector } from "react-redux";
import { bplrtAXIOS } from "../../../../config/axios";
import { instanceBPLRTDisruptionAPI } from "../../../../api";
import MapSelections from "./map/MapSelections";
import SaveDisruption from "./map/SaveDisruption";
import { logger } from "../../../../helpers/logger";
import { cloneArray } from "../../../../helpers/arrayHelper";
import { handleTimeoutPrompt } from "../../../store/actions/bplrt/smpAction";
import {
  SET_ERROR_MESSAGE_SMP_DISRUPTION,
  SET_ERROR_PROMPT_SMP_DISRUPTION,
  SET_SUCCESS_MESSAGE_SMP_DISRUPTION,
  SET_SUCCESS_PROMPT_SMP_DISRUPTION,
} from "../../../store/actionTypes/bplrt/smpActionType";
import { handleError } from "../../../../store/handleError";
import { useTranslation } from "react-i18next";
const InteractableMap = () => {
  const dispatch = useDispatch();
  const { platformDisruptions, trackDisruptions, textDisruptions } =
    useSelector((state) => state.bplrtSmp);

  const { t } = useTranslation("bplrtSmp");

  const [initPlatformData, setInitPlatformData] = useState([]);
  const [initTrackData, setInitTrackData] = useState([]);
  const [initTextData, setInitTextData] = useState([]);

  const [platformData, setPlatformData] = useState([]);
  const [trackData, setTrackData] = useState([]);
  const [textData, setTextData] = useState([]);
  const [triggerResetState, setTriggerResetState] = useState(0);

  const [isChanged, setIsChanged] = useState(false);
  const [loadingText, setLoadingText] = useState(false);

  useEffect(() => {
    setInitPlatformData(cloneArray(platformDisruptions));
    setInitTrackData(cloneArray(trackDisruptions));
    setPlatformData(platformDisruptions);
    setTrackData(trackDisruptions);
  }, [platformDisruptions, trackDisruptions, textDisruptions]);

  useEffect(() => {
    setInitTextData(cloneArray(textDisruptions));
    setTextData(textDisruptions);
  }, [textDisruptions]);

  const getPreviewDisruptionText = async (payload) => {
    const access_token = sessionStorage.getItem("access_token");
    setLoadingText(true);
    try {
      const { data } = await bplrtAXIOS.post(
        instanceBPLRTDisruptionAPI + "track/preview",
        payload,
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      setTextData(data.messages);

      dispatch({ type: SET_SUCCESS_PROMPT_SMP_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_SMP_DISRUPTION,
        payload: t("message.previewSuccess"),
      });
      handleTimeoutPrompt(dispatch, SET_SUCCESS_PROMPT_SMP_DISRUPTION);
    } catch (error) {
      const errorMessage = handleError(error);
      console.log(errorMessage);
      dispatch({ type: SET_ERROR_PROMPT_SMP_DISRUPTION, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_SMP_DISRUPTION,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_SMP_DISRUPTION);
      logger.error(error);
    } finally {
      setLoadingText(false);
    }
  };

  const getTextPreview = (tracks) => {
    if (tracks.length !== 0) {
      const newArray = tracks.map(({ id, isDisrupted, ...track }) => {
        return { id, isDisrupted };
      });
      const payload = { trackUpdate: { tracks: newArray } };

      getPreviewDisruptionText(payload);
    }
  };

  const handleIsChanged = () => {
    if (!isChanged) setIsChanged(true);
  };

  const handleResetState = () => {
    setTriggerResetState(triggerResetState + 1);
  };

  const tracksArray = (array1, array2, disrupted) => {
    const arr = array1.concat(array2);
    const newArr = arr.map(({ id }) => ({
      id,
      isDisrupted: disrupted,
    }));
    return newArr;
  };

  const trackChangeDisruption = (disruption) => {
    const disrupted = !disruption?.isDisrupted;
    const newArray = trackData.map((data) => {
      if (data.id === disruption.id) data.isDisrupted = disrupted;
      return data;
    });
    setTrackData(newArray);
    handleIsChanged();
  };

  const platformChangeDisruption = (disruption) => {
    const disrupted = !disruption?.isDisrupted;

    let platformTrack = {};
    platformTrack["inboundTracks"] = trackDisruptions.filter(
      (t) => t.toPlatformId === disruption.id
    );
    platformTrack["outboundTracks"] = trackDisruptions.filter(
      (t) => t.fromPlatformId === disruption.id
    );

    logger.log(platformTrack);

    const newArray = platformData.map((data) => {
      if (data.id === disruption.id) {
        data.isDisrupted = disrupted;
        tracksArray(
          platformTrack.inboundTracks,
          platformTrack.outboundTracks,
          !disrupted
        ).forEach((item) => trackChangeDisruption(item));
      }
      return data;
    });
    setPlatformData(newArray);
    handleIsChanged();
  };

  const refreshChange = () => {
    logger.log(platformDisruptions);
    setPlatformData(cloneArray(initPlatformData));
    setTrackData(cloneArray(initTrackData));
    setTextData(cloneArray(initTextData));
    setTriggerResetState(triggerResetState + 1);
    setIsChanged(false);
  };

  return (
    <>
      <Box>
        <Grid container alignItems="flex-end">
          <Grid item sx={{ mb: "8px" }}>
            <ResetAllDisruption
              platformData={platformData}
              trackData={trackData}
              handleResetState={handleResetState}
              setIsChanged={setIsChanged}
            />

            <SaveDisruption
              platformData={platformData}
              trackData={trackData}
              handleResetState={handleResetState}
              setIsChanged={setIsChanged}
              isChanged={isChanged}
            />

            <Button
              variant="contained"
              onClick={() => {
                getTextPreview(trackData);
              }}
              sx={{ boxShadow: 3, mr: "8px" }}
            >
              {t("previewBtn")}
            </Button>
          </Grid>

          <Grid item>
            <MapSelections
              platformData={platformData}
              setPlatformData={setPlatformData}
              trackData={trackData}
              setTrackData={setTrackData}
              handleIsChanged={handleIsChanged}
              isChanged={isChanged}
              refreshChange={refreshChange}
              triggerResetState={triggerResetState}
            />
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "95%", maxHeight: "500px", margin: "8px" }}>
            <MapComponents
              platformData={platformData}
              trackData={trackData}
              platformChangeDisruption={platformChangeDisruption}
              trackChangeDisruption={trackChangeDisruption}
              textData={textData}
              loadingText={loadingText}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InteractableMap;
